import React, { MouseEvent } from "react";
import "./style.scss";
import logo from "../../assets/images/openLogo.svg";
import {useTranslation} from "react-i18next";
import { useNavigate } from "react-router";
import config from "../../config/default.json";
import { getHost } from "../../helpers/ApiHelper";
import useLayoutStyles from "../../hooks/styles";

const Header = () => {
    let timerId: NodeJS.Timeout | null = null;
    let clickCount = 0;

    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    const logoClick = (e: MouseEvent<HTMLImageElement>) => {
        e.stopPropagation();

        clickCount++;
        if (clickCount >= config.other.clickCount) {
            navigate("/settings");
        }

        if (!timerId) {
            timerId = setTimeout(() => {
                clickCount = 0;
                timerId = null;
            }, config.other.settingsClickTimer);
        }
    }

    if (styles?.general.logoImage) {
        return <div className="Header">
            <img className="logo" src={`${getHost()}${styles.general.logoImage}`} alt={t("companyName")} onClick={logoClick} />
        </div>
    }

    return <div className="Header">
        <img className="logo" src={logo} alt={t("companyName")} onClick={logoClick} />
    </div>
}

export default Header;
